import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredMga = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 5"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M5.05288 0.056026V4.94412C5.05288 4.97503 5.02803 5 4.99727 5H2.58206C2.55129 5 2.52644 4.97503 2.52644 4.94412V2.8871C2.52644 2.73371 2.34184 2.65762 2.23415 2.76582L0.0946676 4.91558C0.0591673 4.95125 0 4.92628 0 4.87634V0.0667273C0 0.0167881 0.0603506 -0.00818146 0.0946676 0.0274893L2.37497 2.3128C2.45781 2.39484 2.59153 2.39365 2.67436 2.31161L4.95703 0.0167881C4.99253 -0.0188827 5.0517 0.00608689 5.0517 0.056026" />
    <path d="M6.73682 3.93339V1.06665H7.53912L8.3296 3.17123L9.09641 1.06665H9.88096V3.93339H9.29876V2.01312L8.5568 3.93339H8.0598L7.32021 2.01312V3.93339H6.73682Z" />
    <path d="M10.6277 3.55767C10.3792 3.29252 10.2561 2.94057 10.2561 2.50063C10.2561 2.06069 10.3839 1.70517 10.636 1.44001C10.888 1.17605 11.2324 1.04407 11.6678 1.04407C12.0075 1.04407 12.2926 1.14038 12.5187 1.33181C12.7459 1.52325 12.8772 1.77532 12.9151 2.08684H12.3045C12.2311 1.76462 11.9944 1.56367 11.6525 1.56367C11.4158 1.56367 11.2288 1.64928 11.0892 1.82288C10.9484 1.99648 10.8785 2.22239 10.8785 2.50063C10.8785 2.77886 10.9484 3.00834 11.0856 3.17956C11.2229 3.35197 11.4122 3.43758 11.6525 3.43758C11.9743 3.43758 12.3092 3.26517 12.3648 2.86447V2.8288H11.6572V2.3413H12.9316V3.9334H12.5045L12.4429 3.58977C12.2784 3.80737 11.9933 3.95718 11.6134 3.95718C11.2051 3.95718 10.8774 3.82282 10.6289 3.55767" />
    <path d="M13.8214 3.93343H13.1895L14.232 1.06787H14.9657L15.9999 3.93343H15.3455L15.1242 3.308H14.0403L13.8214 3.93343ZM14.5787 1.72302L14.2024 2.81217H14.9562L14.5787 1.72302Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgColouredMga)
const IconSvgColouredMga = createIcon(ForwardRef, 'SvgColouredMga')
export default IconSvgColouredMga
